import React from "react";
import { Col } from "react-bootstrap";
import style from "../ThemesLayout.module.css";
import AdvanceThemeJson from "./ThemePropertiesJson/AdvanceThemeJson";
import Autocomplete from "@material-ui/lab/Autocomplete";
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import CloseIcon from "@material-ui/icons/Close";
import Chip from "@material-ui/core/Chip";
import {TextField} from "@material-ui/core";
import LayoutComponent from "./LayoutComponent";
import StyleComponent from "./StyleComponent";
import { useTranslation } from "react-i18next";
import {
  makeStyles,
  createTheme,
  ThemeProvider,
} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiSlider-thumb": {
      marginRight: -5,
      marginLeft: 0,
    },
  },
  auto:{
      padding: 0,
      margin: "4px",
      border: "1px solid #C4C4C4",
      "& .MuiChip-root": {
        borderRadius: 2,
        width: "90px",
        height: "25px",
        backgroundColor: "#F0F0F0",
      },
      "& .MuiButtonBase-root": {
        margin: "0 !important",
      },
      "& .MuiInputBase-input": {
        border: "none !important",
        flexGrow: "0",
        width: "0px !important",
        minWidth: "90px !important",
      },
  
      "& .MuiAutocomplete-endAdornment": {
        right:
          window?.psh_configs?.selectedLanguage === "ar" ||
          window?.psh_configs?.selectedLanguage === "ar-SA"
            ? "unset"
            : null,
        left:
          window?.psh_configs?.selectedLanguage === "ar" ||
          window?.psh_configs?.selectedLanguage === "ar-SA"
            ? "-183px"
            : null,
      },
      "& .MuiChip-deleteIcon": {
        marginRight:
          window?.psh_configs?.selectedLanguage === "ar" ||
          window?.psh_configs?.selectedLanguage === "ar-SA"
            ? "unset"
            : null,
        marginLeft:
          window?.psh_configs?.selectedLanguage === "ar" ||
          window?.psh_configs?.selectedLanguage === "ar-SA"
            ? "5px"
            : null,
      },
    },
  inputRoot: {
    "& .MuiOutlinedInput-root": {
      "& .MuiAutocomplete-endAdornment": {
        right:
          window?.psh_configs?.selectedLanguage === "ar" ||
          window?.psh_configs?.selectedLanguage === "ar-SA"
            ? "unset"
            : null,
        left:
          window?.psh_configs?.selectedLanguage === "ar" ||
          window?.psh_configs?.selectedLanguage === "ar-SA"
            ? "9px"
            : null,
      },
      "& .MuiAutocomplete-inputRoot": {
        paddingRight: "unset !important",
      },
    },
    "& .MuiAutocomplete-inputRoot": {
      paddingRight: "unset !important",
    },
    // "& .MuiAutocomplete-clearIndicator": {
    //   display: "none",
    // },
  },
}));
const SelectedControlThemeProperties = (props) => {
  const { t } = useTranslation();
  const defaultValue = '16';
  const classes = useStyles();
  const translationStyles1 =
    window?.psh_configs?.selectedLanguage === "ar" ||
    window?.psh_configs?.selectedLanguage === "ar-SA";
  return (
    <div className={style.advanceThemeRoot1}>
      {AdvanceThemeJson && AdvanceThemeJson[props.selectedControl] ? (
        Object.keys(AdvanceThemeJson[props.selectedControl]).map(
          (key, index) => {
            if (key === "layout") {
              return (
                <>
                  <Col className={style.selectedControlHeading}>
                    {t(
                      `${AdvanceThemeJson[props.selectedControl][key].header}`
                    )}
                  </Col>
                  {AdvanceThemeJson[props.selectedControl][key] &&
                  AdvanceThemeJson[props.selectedControl][key].subHeader ? (
                    AdvanceThemeJson[props.selectedControl][key].subHeader.map(
                      (details, index) => {
                        return (
                          <LayoutComponent
                            selectedControl={props.selectedControl}
                            themeKey={props.themeKey}
                            selectedTheme={props.selectedTheme}
                            imgStyle={
                              props.selectedControl === "Vertical Wizard" ||
                              "Vertical Tabs"
                                ? { height: "100%" }
                                : null
                            }
                            styleData={details}
                            handleProperty={(arg1, arg2) =>
                              props.handleProperty(arg1, arg2)
                            }
                          />
                        );
                      }
                    )
                  ) : (
                    <></>
                  )}
                </>
              );
            } else if (key === "style") {
              return (
                <>
                  <Col className={style.selectedControlHeading}>
                    {t(
                      `${AdvanceThemeJson[props.selectedControl][key].header}`
                    )}
                  </Col>
                  {translationStyles1 && props?.selectedControl?.["Inputs"]
                    ? AdvanceThemeJson[props.selectedControl][key] &&
                      AdvanceThemeJson[props.selectedControl][
                        key
                      ].subHeaderArabic.map((details, index) => {
                        return (
                          <StyleComponent
                            themeKey={props.themeKey}
                            selectedTheme={props.selectedTheme}
                            selectedControl={props.selectedControl}
                            stylingProperties={details}
                            handleProperty={(arg1, arg2) =>
                              props.handleProperty(arg1, arg2)
                            }
                          />
                        );
                      })
                    : AdvanceThemeJson[props.selectedControl][key] &&
                      AdvanceThemeJson[props.selectedControl][
                        key
                      ].subHeader.map((details, index) => {
                        return (
                          <StyleComponent
                            themeKey={props.themeKey}
                            selectedTheme={props.selectedTheme}
                            selectedControl={props.selectedControl}
                            stylingProperties={details}
                            handleProperty={(arg1, arg2) =>
                              props.handleProperty(arg1, arg2)
                            }
                          />
                        );
                      })}
                </>
              );
            }
            else if (key === "CustomSpacingAdvTheme"){
              return(
              <div className={style.stylingComponent}>
              <Col
              style={{ marginBottom:"15px",fontWeight: "bold",
              letterSpacing:" 0px",
              color: "#045ca4",
              padding: "0px !important",
              opacity: 1}}
            >
              {t("translation:Spacing")}
            </Col>
                <div>
                <div>
                <h5 style={{font: "normal normal 600 12px/16px Open Sans"}}>Outer Padding</h5>
                <div style={{display:"flex",alignItems:"center",marginBottom:"8px",justifyContent:"space-between"}}>
                <label>Vertical Spacing</label>
                <div>
                          <div className={classes.auto} style={{ width: "100%",backgroundColor:"white" }}>
                            <Autocomplete
                            freeSolo
                            forcePopupIcon
                            popupIcon={<KeyboardArrowDownIcon />}
                            value={props?.selectedTheme?.["HorizontalTabStyle"] ? props?.selectedTheme?.["HorizontalTabStyle"]["Vertical Spacing"] || defaultValue : defaultValue}
                            className={classes.inputRoot}
                              id="tags-filled"
                              options={AdvanceThemeJson["Horizontal Tabs"]["CustomSpacingAdvTheme"].map((title, index) => title.Title)}
                              onBlur={(event, value) =>
                                props.handleProperty("Vertical Spacing" ,event?.target?.value)
                              }
                              inputProps={{ "aria-label": "Input Value" }}
                              aria-label="Input Value"
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                  variant="outlined"
                                  label={option.Title}
                                  deleteIcon={
                                    <CloseIcon style={{ width: "15px" }} />
                                  }
                                  className={classes.customChip}
                                  {...getTagProps({ index })}
                                  />
                                ))
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder=""
                                  ariaLabel="Input Value"
                                  type="number"
                                  onBlur={(event, value) =>
                                    props.handleProperty("Vertical Spacing" ,event?.target?.value)
                                  }
                                  InputProps={{
                                    ...params.InputProps,
                                    "aria-label": "Input Value", // Set the aria-label here
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>   
                        </div>
                <div style={{display:"flex",alignItems:"center",marginBottom:"8px",justifyContent:"space-between"}}>
                <label>Horizontal Spacing</label>
                <div>
                          <div className={classes.auto} style={{ width: "100%",backgroundColor:"white" }}>
                            <Autocomplete
                            freeSolo
                            forcePopupIcon
                            popupIcon={<KeyboardArrowDownIcon />}
                            className={classes.inputRoot}
                            value={props?.selectedTheme?.["HorizontalTabStyle"] ? props?.selectedTheme?.["HorizontalTabStyle"]["Horizontal Spacing"] || defaultValue : defaultValue}
                              id="tags-filled"
                              options={AdvanceThemeJson["Horizontal Tabs"]["CustomSpacingAdvTheme"].map((title, index) => title.Title)}
                              onBlur={(event, value) =>
                                props.handleProperty("Horizontal Spacing" ,event?.target?.value)
                              }
                              inputProps={{ "aria-label": "Input Value" }}
                              aria-label="Input Value"
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                  variant="outlined"
                                  label={option.Title}
                                  deleteIcon={
                                    <CloseIcon style={{ width: "15px" }} />
                                  }
                                  className={classes.customChip}
                                  {...getTagProps({ index })}
                                  />
                                ))
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder=""
                                  ariaLabel="Input Value"
                                  type="number"
                                  onBlur={(event, value) =>
                                    props.handleProperty("Horizontal Spacing" ,event?.target?.value)
                                  }
                                  InputProps={{
                                    ...params.InputProps,
                                    "aria-label": "Input Value", // Set the aria-label here
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                </div>     
                </div> 
                <div>
                <h5 style={{font: "normal normal 600 12px/16px Open Sans"}}>Inner Padding</h5>
                <div style={{display:"flex",alignItems:"center",marginBottom:"8px",justifyContent:"space-between"}}>
                <label>Spacing Left</label>
                <div >
                          <div className={classes.auto} style={{ width: "100%" ,backgroundColor:"white" }}>
                            <Autocomplete
                            freeSolo
                            forcePopupIcon
                            popupIcon={<KeyboardArrowDownIcon />}
                            value={props?.selectedTheme?.["HorizontalTabStyle"] ? props?.selectedTheme?.["HorizontalTabStyle"]["Spacing Left"] || defaultValue : defaultValue}
                           // defaultValue={props?.selectedTheme?.["Section Spacing"] ? props?.selectedTheme?.["Section Spacing"]["Spacing Left"] || defaultValue : defaultValue}
                            className={classes.inputRoot}
                              id="tags-filled"
                              options={AdvanceThemeJson["Horizontal Tabs"]["CustomSpacingAdvTheme"].map((title, index) => title.Title)}
                              onBlur={(event, value) =>
                                props.handleProperty("Spacing Left" ,event?.target?.value)
                              }
                              inputProps={{ "aria-label": "Input Value" }}
                              aria-label="Input Value"
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                  variant="outlined"
                                  label={option.Title}
                                  deleteIcon={
                                    <CloseIcon style={{ width: "15px" }} />
                                  }
                                  className={classes.customChip}
                                  {...getTagProps({ index })}
                                  />
                                ))
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder=""
                                  ariaLabel="Input Value"
                                  type="number"
                                  onBlur={(event, value) =>
                                    props.handleProperty("Spacing Left" ,event?.target?.value)
                                  }
                                  InputProps={{
                                    ...params.InputProps,
                                    "aria-label": "Input Value", // Set the aria-label here
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                </div>    
                <div style={{display:"flex",alignItems:"center",marginBottom:"8px",justifyContent:"space-between"}}>
                <label>Spacing Right</label>
                <div>
                          <div className={classes.auto} style={{ width: "100%",backgroundColor:"white"  }}>
                            <Autocomplete
                            freeSolo
                            forcePopupIcon
                            popupIcon={<KeyboardArrowDownIcon />}
                            value={props?.selectedTheme?.["HorizontalTabStyle"] ? props?.selectedTheme?.["HorizontalTabStyle"]["Spacing Right"] || defaultValue : defaultValue}
                            //defaultValue={props?.selectedTheme?.["Section Spacing"] ? props?.selectedTheme?.["Section Spacing"]["Spacing Right"] || defaultValue : defaultValue}
                            className={classes.inputRoot}
                              id="tags-filled"
                              options={AdvanceThemeJson["Horizontal Tabs"]["CustomSpacingAdvTheme"].map((title, index) => title.Title)}
                              onBlur={(event, value) =>
                                props.handleProperty("Spacing Right" ,event?.target?.value)
                              }
                              inputProps={{ "aria-label": "Input Value" }}
                              aria-label="Input Value"
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                  variant="outlined"
                                  label={option.Title}
                                  deleteIcon={
                                    <CloseIcon style={{ width: "15px" }} />
                                  }
                                  className={classes.customChip}
                                  {...getTagProps({ index })}
                                  />
                                ))
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder=""
                                  ariaLabel="Input Value"
                                  type="number"
                                  onBlur={(event, value) =>
                                    props.handleProperty("Spacing Right" ,event?.target?.value)
                                  }
                                  InputProps={{
                                    ...params.InputProps,
                                    "aria-label": "Input Value", // Set the aria-label here
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                </div>  
                <div style={{display:"flex",alignItems:"center",marginBottom:"8px",justifyContent:"space-between"}}>
                <label>Spacing Top</label>
                <div>
                          <div className={classes.auto} style={{ width: "100%" ,backgroundColor:"white" }}>
                            <Autocomplete
                            freeSolo
                            forcePopupIcon
                            popupIcon={<KeyboardArrowDownIcon />}
                            value={props?.selectedTheme?.["HorizontalTabStyle"] ? props?.selectedTheme?.["HorizontalTabStyle"]["Spacing Top"] || defaultValue : defaultValue}
                            //defaultValue={props?.selectedTheme?.["Section Spacing"] ? props?.selectedTheme?.["Section Spacing"]["Spacing Top"] || defaultValue : defaultValue}
                            className={classes.inputRoot}
                              id="tags-filled"
                              options={AdvanceThemeJson["Horizontal Tabs"]["CustomSpacingAdvTheme"].map((title, index) => title.Title)}
                              onBlur={(event, value) =>
                                props.handleProperty("Spacing Top" ,event?.target?.value)
                              }
                              inputProps={{ "aria-label": "Input Value" }}
                              aria-label="Input Value"
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                  variant="outlined"
                                  label={option.Title}
                                  deleteIcon={
                                    <CloseIcon style={{ width: "15px" }} />
                                  }
                                  className={classes.customChip}
                                  {...getTagProps({ index })}
                                  />
                                ))
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder=""
                                  ariaLabel="Input Value"
                                  type="number"
                                  onBlur={(event, value) =>
                                    props.handleProperty("Spacing Top" ,event?.target?.value)
                                  }
                                  InputProps={{
                                    ...params.InputProps,
                                    "aria-label": "Input Value", // Set the aria-label here
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                </div>   
                <div style={{display:"flex",alignItems:"center",marginBottom:"8px",justifyContent:"space-between"}}>
                <label>Spacing Bottom</label>
                <div>
                          <div className={classes.auto} style={{ width: "100%" ,backgroundColor:"white" }}>
                            <Autocomplete
                            freeSolo
                            forcePopupIcon
                            popupIcon={<KeyboardArrowDownIcon />}
                            value={props?.selectedTheme?.["HorizontalTabStyle"] ? props?.selectedTheme?.["HorizontalTabStyle"]["Spacing Bottom"] || defaultValue : defaultValue}
                           // defaultValue={props?.selectedTheme?.["Section Spacing"] ? props?.selectedTheme?.["Section Spacing"]["Spacing Bottom"]  || defaultValue : defaultValue}
                            className={classes.inputRoot}
                              id="tags-filled"
                              options={AdvanceThemeJson["Horizontal Tabs"]["CustomSpacingAdvTheme"].map((title, index) => title.Title)}
                              onBlur={(event, value) =>
                                props.handleProperty("Spacing Bottom" ,event?.target?.value)
                              }
                              inputProps={{ "aria-label": "Input Value" }}
                              aria-label="Input Value"
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => (
                                  <Chip
                                  variant="outlined"
                                  label={option.Title}
                                  deleteIcon={
                                    <CloseIcon style={{ width: "15px" }} />
                                  }
                                  className={classes.customChip}
                                  {...getTagProps({ index })}
                                  />
                                ))
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  placeholder=""
                                  ariaLabel="Input Value"
                                  type="number"
                                  onBlur={(event, value) =>
                                    props.handleProperty("Spacing Bottom" ,event?.target?.value)
                                  }
                                  InputProps={{
                                    ...params.InputProps,
                                    "aria-label": "Input Value", // Set the aria-label here
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                </div>      
                </div>   
                </div>                                                
              </div>
            
              )
              

            }
          }
        )
      ) : (
        <></>
      )}
    </div>
  );
};

export default SelectedControlThemeProperties;
